import React from "react";
import "./red-icon.m.css";

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="113" height="113" viewBox="0 0 39.755 37.164">
      <g data-name="Group 4687" transform="translate(-2589.727 6610)">
        <path
          d="M421.5 721.569a14.127 14.127 0 10-14.125-14.123 14.126 14.126 0 0014.125 14.123z"
          styleName="cls-1"
          data-name="Path 69"
          transform="translate(2188.002 -7294.405)"
        ></path>
        <g data-name="Group 2543" transform="translate(2188.002 -7294.405)">
          <path
            d="M0 0h1.438v7.029H0z"
            styleName="cls-1"
            data-name="Rectangle 522"
            transform="rotate(-.065 603496.097 -370560.664)"
          ></path>
        </g>
        <g data-name="Group 2544" transform="translate(2188.002 -7294.405)">
          <path
            d="M0 0h7.074v1.439H0z"
            styleName="cls-1"
            data-name="Rectangle 523"
            transform="rotate(-60.954 803.45 -17.818)"
          ></path>
        </g>
        <g data-name="Group 2545" transform="translate(2188.002 -7294.405)">
          <path
            d="M0 0h7.028v1.439H0z"
            styleName="cls-1"
            data-name="Rectangle 524"
            transform="rotate(-31.57 1452.087 -419.525)"
          ></path>
        </g>
        <g data-name="Group 2546" transform="translate(2188.002 -7294.405)">
          <path
            d="M0 0h1.439v7.008H0z"
            styleName="cls-1"
            data-name="Rectangle 525"
            transform="rotate(-29.2 1524.403 -442.588)"
          ></path>
        </g>
        <g data-name="Group 2547" transform="translate(2188.002 -7294.405)">
          <path
            d="M0 0h1.439v6.98H0z"
            styleName="cls-1"
            data-name="Rectangle 526"
            transform="rotate(-59.23 813.327 -5.226)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
